import React from 'react';
import { Avatar, Button, Typography } from 'antd';

const { Text } = Typography;

interface AIIntroductionProps {
  contactName: string;
  onSuggestedAction: (action: string) => void;
}

const SUGGESTED_ACTIONS = [
  'Draft a personalized follow-up',
  'Analyze interests & pain points',
  'Suggest conversation topics',
  'Review engagement history'
];

export const AIIntroduction: React.FC<AIIntroductionProps> = ({ 
  contactName, 
  onSuggestedAction 
}) => (
  <>
    <div className="message ai-message">
      <Avatar className="message-avatar">
        <Text className="avatar-text">AI</Text>
      </Avatar>
      <div className="message-content ai-introduction">
        <div className="introduction-message">
          <Text className="message-text">
            Hello! I'm your AI sales assistant with full context about <strong>{contactName}</strong>.
            I have access to their profile information, conversation history, and can help you craft
            personalized outreach strategies.
          </Text>
          <Text className="message-text">
            What would you like to know or how can I help you engage with this lead?
          </Text>
        </div>
      </div>
    </div>

    <div className="message ai-message">
      <Avatar className="message-avatar">
        <Text className="avatar-text">AI</Text>
      </Avatar>
      <div className="message-content ai-introduction">
        <div className="suggested-actions">
          <Text className="actions-title">
            Here are some quick actions you can take:
          </Text>
          <div className="actions-buttons">
            {SUGGESTED_ACTIONS.map((action, index) => (
              <Button
                key={index}
                size="small"
                onClick={() => onSuggestedAction(action)}
                className="action-button"
              >
                {action}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  </>
);
